
import { IUserProfile } from './i-user-profile';

export class UserProfile {
	constructor(profileData: IUserProfile) {
		this.myProjects = !!profileData["myProjects"] ? profileData["myProjects"] : new Array<number>();
		this.myStores = !!profileData["myStores"] ? profileData["myStores"] : new Array<number>();
		this.myContracts = !!profileData["myContracts"] ? profileData["myContracts"] : new Array<number>();
		this.storeMenuOrientation = !!profileData["storeMenuOrientation"] ? profileData["storeMenuOrientation"] : 0;
	}

	storeMenuOrientation: number;

	myProjects: number[];
	myStores: number[];
	myContracts: number[];
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/_entities/user-profile.ts